import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Image from "@pages/Other/element/Image";

function CoursePreview({ courseName, courseImg, courseVid, toogle }) {
  const { t } = useTranslation();
  const courseVidRef = useRef();
  const [playPreview, setPlayPreview] = useState(false);

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const handlePlayVideo = (e) => {
    preventDefault(e);
    setPlayPreview(!playPreview);
    if (courseVidRef.current.paused) {
      courseVidRef.current.play();
    } else {
      courseVidRef.current.pause();
    }
  };

  return (
    <div className="preview-innerlay">
      <div className="preview-course-header">{t("COURSE VIDEO PREVIEW")}</div>

      <div className="preview-close">
        {" "}
        <div onClick={() => toogle(false)}>
          <i className="icon check" />
        </div>
      </div>

      <div className="preview-course-header2">{t(courseName)}</div>
      <div className="preview-thumbnail" onClick={handlePlayVideo}>
        {!playPreview && (
          <div className="preview-inner">
            <div className="play-icon-contanier">
              <Image
                className="play-icon"
                url={`${process.env.REACT_APP_SMIK_API_BASEURL}/UI/icons/icon_video_play.svg`}
                alt="play-button"
              />
            </div>
            <Image
              url={courseImg && courseImg}
              alt="Please upload course-thumbnail image"
            />
          </div>
        )}
        <video ref={courseVidRef} controls={true}>
          <source src={`${courseVid}`} type="video/mp4" />
        </video>
      </div>
    </div>
  );
}

export default CoursePreview;
